module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "level-form"
    }
  }, [_c('v-card', [(_vm.data) ? _c('v-expansion-panels', {
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.data), function(row, i) {
    return _c('v-expansion-panel', {
      key: i,
      staticClass: "mb-3",
      staticStyle: {
        "border": "1.5px solid #f0f0f0",
        "border-radius": "5px"
      }
    }, [_c('v-expansion-panel-header', {
      staticClass: "font-weight-bold"
    }, [_vm._v("\n                    Interpretasi " + _vm._s(i + 1) + "\n                ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', [_c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-500"
    }, [_c('div', [_c('v-btn', {
      staticClass: "font-weight-bold green--text mt-0 mb-3",
      attrs: {
        "depressed": "",
        "color": "#E2F5EA"
      },
      on: {
        "click": function($event) {
          return _vm.previewPage()
        }
      }
    }, [_vm._v("\n                                            Preview\n                                        ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex mb-5",
      staticStyle: {
        "align-items": "center",
        "justify-content": "space-between"
      }
    }, [(
      _vm.detail_scale.question_type ===
      'choice'
    ) ? _c('div', [_c('div', {
      staticClass: "font-weight-600",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                                                Kode Dominan\n                                            ")]), _vm._v(" "), _c('div', {
      staticClass: "font-weight-500 black60--text mt-1",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                                                " + _vm._s(row.most_value || "-") + "\n                                            ")])]) : _c('div', [_c('div', {
      staticClass: "font-weight-600",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                                                Rentang Score\n                                            ")]), _vm._v(" "), _c('div', {
      staticClass: "font-weight-500 black60--text mt-1",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                                                " + _vm._s(row.min_result || 0) + " -\n                                                " + _vm._s(row.max_result || 0) + "\n                                            ")])]), _vm._v(" "), _c('div', [_c('v-btn', {
      staticClass: "primary--text mr-8",
      attrs: {
        "depressed": "",
        "color": "#e2f0f7",
        "x-small": "",
        "height": "40"
      },
      on: {
        "click": function($event) {
          return _vm.editRange(row)
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v("\n                                                    mdi-pencil\n                                                ")])], 1)], 1)]), _vm._v(" "), _c('div', [(!row.pages.length) ? _c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pa-3"
    }, [_c('div', {
      staticClass: "d-flex",
      staticStyle: {
        "justify-content": "space-between",
        "align-items": "center"
      }
    }, [_c('div', {
      staticClass: "font-weight-600"
    }, [_vm._v("\n                                                        Page 1\n                                                    ")]), _vm._v(" "), _c('div', [_c('v-btn', {
      staticClass: "font-weight-bold blew--text mt-0",
      staticStyle: {
        "margin-right": "auto"
      },
      attrs: {
        "text": "",
        "depressed": "",
        "color": "#e8f5fa"
      },
      on: {
        "click": function($event) {
          return _vm.addInterpretation(
            row
          )
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      staticStyle: {
        "font-size": "16px !important"
      }
    }, [_vm._v("\n                                                                mdi-plus-circle\n                                                            ")]), _vm._v("\n                                                            Tambah Jenis\n                                                            Interpretasi\n                                                        ")], 1)], 1)])])], 1) : _vm._e(), _vm._v(" "), _vm._l((row.pages), function(page, index) {
      return _c('v-card', {
        key: index,
        staticClass: "mt-5",
        attrs: {
          "color": "#f9fafc",
          "flat": ""
        }
      }, [_c('v-card-text', {
        staticClass: "pa-5"
      }, [_c('div', {
        staticClass: "d-flex",
        staticStyle: {
          "justify-content": "space-between",
          "align-items": "center",
          "padding-top": "-10px",
          "padding-bottom": "7px"
        }
      }, [_c('div', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                                        Page " + _vm._s(index + 1) + "\n                                                    ")]), _vm._v(" "), (
        index + 1 !== 1
      ) ? _c('div', [_c('v-btn', {
        staticClass: "font-weight-bold blew--text mt-0",
        staticStyle: {
          "margin-right": "auto"
        },
        attrs: {
          "text": "",
          "depressed": "",
          "color": "#e8f5fa",
          "disabled": page
            .sub_interpretation
            .length ===
            2
        },
        on: {
          "click": function($event) {
            return _vm.addSubInterpretation(
              index +
              1,
              row
            )
          }
        }
      }, [_c('v-icon', {
        staticClass: "mr-1",
        staticStyle: {
          "font-size": "16px !important"
        }
      }, [_vm._v("\n                                                                mdi-plus-circle\n                                                            ")]), _vm._v("\n                                                            Tambah Sub\n                                                            Interpretasi\n                                                        ")], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "mt-2"
      }, [(index === 0) ? _c('div', _vm._l((page.sub_interpretation), function(sub, i) {
        return _c('v-card', {
          key: i,
          staticClass: "mb-5",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-card-title', [_c('span', {
          staticClass: "font-weight-bold",
          staticStyle: {
            "font-size": "14px"
          }
        }, [_vm._v("\n                                                                    Interpretasi\n                                                                ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          staticClass: "primary--text",
          attrs: {
            "depressed": "",
            "color": "#e2f0f7",
            "x-small": "",
            "height": "40"
          },
          on: {
            "click": function($event) {
              return _vm.editInterpretation(
                sub
              )
            }
          }
        }, [_c('v-icon', {
          staticStyle: {
            "font-size": "20px"
          }
        }, [_vm._v("\n                                                                        mdi-pencil\n                                                                    ")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "font-weight-600"
        }, [_vm._v("\n                                                                    Judul\n                                                                    Interpretasi\n                                                                ")]), _vm._v(" "), _c('div', [_vm._v("\n                                                                    " + _vm._s(sub.title) + "\n                                                                ")]), _vm._v(" "), (
          sub.icon
        ) ? _c('div', [_c('v-img', {
          staticClass: "mt-3",
          staticStyle: {
            "border-radius": "5px"
          },
          attrs: {
            "src": sub.icon,
            "height": "120",
            "width": "120"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "font-weight-600 mt-3"
        }, [_vm._v("\n                                                                    Deskripsi\n                                                                ")]), _vm._v(" "), _c('div', {
          domProps: {
            "innerHTML": _vm._s(
              sub.description
            )
          }
        })])], 1)
      }), 1) : _c('div', _vm._l((page.sub_interpretation), function(sub, i) {
        return _c('v-card', {
          key: i,
          staticClass: "mb-5",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-card-title', [_c('span', {
          staticClass: "font-weight-bold",
          staticStyle: {
            "font-size": "14px"
          }
        }, [_vm._v("\n                                                                    Sub\n                                                                    Interpretasi\n                                                                    " + _vm._s(i +
          1) + "\n                                                                ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          staticClass: "primary--text",
          attrs: {
            "depressed": "",
            "color": "#e2f0f7",
            "x-small": "",
            "height": "40"
          },
          on: {
            "click": function($event) {
              return _vm.editSubInterpretation(
                sub
              )
            }
          }
        }, [_c('v-icon', {
          staticStyle: {
            "font-size": "20px"
          }
        }, [_vm._v("\n                                                                        mdi-pencil\n                                                                    ")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "font-weight-600"
        }, [_vm._v("\n                                                                    Judul\n                                                                ")]), _vm._v(" "), _c('div', [_vm._v("\n                                                                    " + _vm._s(sub.title) + "\n                                                                ")]), _vm._v(" "), (
          sub.icon
        ) ? _c('div', [_c('v-img', {
          staticClass: "mt-3",
          staticStyle: {
            "border-radius": "5px"
          },
          attrs: {
            "src": sub.icon,
            "height": "120",
            "width": "120"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "font-weight-600 mt-3"
        }, [_vm._v("\n                                                                    Deskripsi\n                                                                ")]), _vm._v(" "), _c('div', {
          domProps: {
            "innerHTML": _vm._s(
              sub.description
            )
          }
        })])], 1)
      }), 1)])])], 1)
    }), _vm._v(" "), (row.cta.length) ? _c('v-card', {
      staticClass: "mt-5",
      attrs: {
        "color": "#f9fafc",
        "flat": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pa-5"
    }, [_c('div', {
      staticClass: "d-flex",
      staticStyle: {
        "justify-content": "space-between",
        "align-items": "center",
        "margin-top": "-5px"
      }
    }, [_c('div', {
      staticClass: "font-weight-600 pb-4 pt-1"
    }, [_vm._v("\n                                                        CTA\n                                                    ")])]), _vm._v(" "), _c('div', _vm._l((row.cta), function(cta, i) {
      return _c('v-card', {
        key: i,
        staticClass: "mb-5",
        attrs: {
          "outlined": ""
        }
      }, [_c('v-card-title', [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "11"
        }
      }, [_c('div', {
        staticStyle: {
          "font-size": "14px"
        }
      }, [_c('div', {
        staticClass: "font-weight-bold",
        staticStyle: {
          "text-transform": "capitalize"
        }
      }, [_vm._v("\n                                                                            " + _vm._s(cta.cta_name ===
        "prodi" ?
        "Career Mapping" :
        cta.cta_name) + "\n                                                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "grey--text font-weight-500",
        staticStyle: {
          "margin-top": "-10px"
        }
      }, [_vm._v("\n                                                                            " + _vm._s(cta.cta_description) + "\n                                                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "mt-5"
      }, [_c('v-row', _vm._l((cta.content), function(data, i) {
        return _c('v-col', {
          key: i,
          attrs: {
            "cols": "4"
          }
        }, [_c('v-card', {
          staticClass: "mb-5",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-card-text', {
          staticClass: "pa-2"
        }, [_c('div', {
          staticClass: "d-flex",
          staticStyle: {
            "align-items": "center",
            "gap": "15px"
          }
        }, [_c('div', [_c('v-img', {
          attrs: {
            "src": data.content_icon,
            "width": "39",
            "height": "39"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "darkgrey--text"
        }, [_vm._v("\n                                                                                                    " + _vm._s(data.content_name) + "\n                                                                                                ")])])])], 1)], 1)
      }), 1)], 1)])]), _vm._v(" "), _c('v-col', [_c('v-btn', {
        staticClass: "primary--text",
        attrs: {
          "depressed": "",
          "color": "#e2f0f7",
          "x-small": "",
          "height": "40"
        },
        on: {
          "click": function($event) {
            return _vm.editSubInterpretation(
              cta
            )
          }
        }
      }, [_c('v-icon', {
        staticStyle: {
          "font-size": "20px"
        }
      }, [_vm._v("\n                                                                            mdi-pencil\n                                                                        ")])], 1)], 1)], 1)], 1)], 1)
    }), 1)])], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "mt-5"
    }, [_c('v-btn', {
      staticClass: "font-weight-bold blew--text mt-0 mb-3",
      attrs: {
        "depressed": "",
        "block": "",
        "disabled": !row.pages.length
      },
      on: {
        "click": function($event) {
          return _vm.addPage(
            row.pages.length + 1,
            row
          )
        }
      }
    }, [_vm._v("\n                                            Tambah Page\n                                        ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "py-3",
      attrs: {
        "align": "right"
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "#868EA4"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDeleteItem(row)
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "color": "red",
        "small": ""
      }
    }, [_vm._v("mdi-delete")]), _vm._v("\n                                        Hapus Interpretasi\n                                    ")], 1)], 1)], 1)], 1)], 1)])], 1)
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.data.length) ? _c('v-card', {
    staticClass: "mb-3",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Belum ada interpretasi")])])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text mt-3",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogRange = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n            Tambah Interpretasi\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 mt-3 ml-2",
    attrs: {
      "depressed": "",
      "color": "blew",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogPotential = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n            Tambah Nama Interpretasi\n        ")], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-5"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('uncompleted', _vm.$attrs.data)
      }
    }
  }, [_vm._v("\n                Kembali\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "color": "blew",
      "type": "button",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.backToScale()
      }
    }
  }, [_vm._v("\n                Selesai\n            ")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "506px"
    },
    on: {
      "click:outside": function($event) {
        _vm.dialogRange = false
      }
    },
    model: {
      value: (_vm.dialogRange),
      callback: function($$v) {
        _vm.dialogRange = $$v
      },
      expression: "dialogRange"
    }
  }, [(_vm.dialogRange) ? _c('dialogRange', {
    attrs: {
      "scale": _vm.detail_scale,
      "detail": _vm.detail_range
    },
    on: {
      "close": function($event) {
        _vm.dialogRange = false
      },
      "save": function($event) {
        return _vm.saveRange()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "506px"
    },
    on: {
      "click:outside": function($event) {
        _vm.dialogInterpretasi = false
      }
    },
    model: {
      value: (_vm.dialogInterpretasi),
      callback: function($$v) {
        _vm.dialogInterpretasi = $$v
      },
      expression: "dialogInterpretasi"
    }
  }, [(_vm.dialogInterpretasi) ? _c('dialogInterpretasi', {
    attrs: {
      "scale": _vm.detail_scale,
      "detail": _vm.detail_interpretasi
    },
    on: {
      "close": function($event) {
        _vm.dialogInterpretasi = false
      },
      "save": function($event) {
        return _vm.saveInterpretation()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.dialogSubInterpretasi) ? _c('v-dialog', {
    attrs: {
      "max-width": "506px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.dialogSubInterpretasi = false
      }
    },
    model: {
      value: (_vm.dialogSubInterpretasi),
      callback: function($$v) {
        _vm.dialogSubInterpretasi = $$v
      },
      expression: "dialogSubInterpretasi"
    }
  }, [_c('dialogSubInterpretasi', {
    attrs: {
      "scale": _vm.detail_scale,
      "detail": _vm.detail_interpretasi
    },
    on: {
      "save": function($event) {
        return _vm.saveInterpretation()
      },
      "close": function($event) {
        _vm.dialogSubInterpretasi = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "490px"
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', {
    staticClass: "py-2"
  }, [_c('v-card-title', {
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                Apakah anda akan menghapus interpretasi ini ?\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v(" interpretasi ini akan dihapus. ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDialog = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "depressed": "",
      "loading": _vm.isLoadingForm
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem()
      }
    }
  }, [_vm._v("\n                    Ok\n                ")])], 1)], 1)], 1), _vm._v(" "), (_vm.dialogPotential) ? _c('v-dialog', {
    attrs: {
      "max-width": "506px",
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogPotential),
      callback: function($$v) {
        _vm.dialogPotential = $$v
      },
      expression: "dialogPotential"
    }
  }, [_c('dialogPotential', {
    attrs: {
      "scale": _vm.detail_scale,
      "detail": _vm.detail_interpretasi
    },
    on: {
      "close": function($event) {
        _vm.dialogPotential = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f145779","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/InterpretationForm.vue
// module id = 1481
// module chunks = 1